import TablePrimary from "../../components/Table/TablePrimary"
import TitleBorderLeft from "../../components/Text/TitleBorderLeft"
import CardSection from "../../components/sections/CardSection/CardSection"
import compliancePageData from "../../data/english/subpages/compliance-page-data"
import Footer from "../../layouts/Footer"
import MainHeader from "../../layouts/MainHeader"

const CompliancePage = () => {
  return (
    <main className="page" id="main">
        
    <div className="sticky-view-two">
        <div className="sticky-container">
            <MainHeader
                image={{
                    src : require(`../../assets/images/wallpaper/${compliancePageData.headerImage.name}`),
                    alt : compliancePageData.headerImage.alt,
                }}
                title=""
            />
        </div>
        <div className="sticky-container-two">
            <div className="wrapper-small">
                <h1 className='title-center'>{compliancePageData.mainTitle}</h1>
                <p className="text-paragraph">{compliancePageData.paragraphOne}</p>
                <TablePrimary 
                    headers={compliancePageData.tableOne.table.headers}
                    textDirection={["s", "e", "e", "e"]}
                    headerBgWhite
                    // note={compliancePageData.tableOne.table.note}
                >
                    {compliancePageData.tableOne.table.data.map((item, index) => (
                        <tr key={index}>
                            <td>{item.element}</td>
                            <td className="td-e">{item[2020]}</td>
                            <td className="td-e">{item[2021]}</td>
                            <td className="bg-light-red td-e">{item[2022]} {index < compliancePageData.tableOne.table.data.length - 1 ? <sup className="red-text a-mark">&#9398;</sup> : ""}</td>
                        </tr>
                    ))}
                </TablePrimary>
                <p className="text-note"><small className="red-text a-mark">&#9398;</small> {compliancePageData.tableOne.table.note}</p>
                <p className="text-paragraph">{compliancePageData.paragraphTwo}</p>
                <p className="text-paragraph">{compliancePageData.paragraphThree}</p>
                <p className="text-paragraph">{compliancePageData.paragraphFour}</p>
                <section>
                    <TitleBorderLeft>
                        {compliancePageData.sectionOne.title}
                    </TitleBorderLeft>
                    <p className="text-paragraph">{compliancePageData.sectionOne.paragraphOne}</p>
                    <p className="text-paragraph">{compliancePageData.sectionOne.paragraphTwo}</p>
                    <p className="text-paragraph">
                        <ol className="order-list">
                            {compliancePageData.sectionOne.orderedList}
                        </ol>
                    </p>
                    <p className="text-paragraph">{compliancePageData.sectionOne.paragraphThree}</p>
                    
                </section>
                <TablePrimary 
                    headers={compliancePageData.tableTwo.table.headers}
                    textDirection={["s", "e", "e", "e"]}
                >
                    {compliancePageData.tableTwo.table.data.map((item, index) => (
                        <tr key={index}>
                            <td>{item.element}</td>
                            <td className="td-e">{item[2020]}</td>
                            <td className="td-e">{item[2021]}</td>
                            <td className="bg-light-red td-e">{item[2022]}</td>
                        </tr>
                    ))}
                </TablePrimary>
                <p className="text-paragraph">
                    {compliancePageData.tableTwo.paragraph}
                </p>
                <div className="space-50"></div>
                <div className="space-50"></div>
                <section>
                    <TitleBorderLeft>{compliancePageData.sectionTwo.title}</TitleBorderLeft>
                    <p className="text-paragraph">{compliancePageData.sectionTwo.paragraphOne}</p>
                    <p className="text-paragraph">{compliancePageData.sectionTwo.paragraphTwo}</p>
                    <p className="text-paragraph">{compliancePageData.sectionTwo.paragraphThree}</p>
                    <h3 className="text-title-normal">{compliancePageData.sectionTwo.titleTwo}</h3>
                    <p className="text-paragraph">{compliancePageData.sectionTwo.paragraphFour}</p>
                    <p className="text-paragraph">{compliancePageData.sectionTwo.paragraphFive}</p>
                </section>
                <TablePrimary headers={compliancePageData.tableThree.table.headers}>
                    {compliancePageData.tableThree.table.data.map((item, index) => (
                        <tr key={index}>
                            <td>{item.name}</td>
                            <td>
                                {item.summary.map((itemTwo, indexTwo) => <p key={index}>{itemTwo}</p>)}
                            </td>
                            <td>{item.length}</td>
                            <td>{item.assessment}</td>
                        </tr>
                    ))}
                </TablePrimary>
                <p className="text-paragraph">
                    {compliancePageData.tableFour.paragraph}
                </p>
                <TablePrimary headers={compliancePageData.tableFour.table.headers}>
                    {
                    compliancePageData.tableFour.table.data.map((item, index) => (
                        <tr key={index}>
                            <td>{item.name}</td>
                            <td>
                                {item.summary.list ?
                                <ul>
                                    {item.summary.list.map((listItem, indexTwo) => (
                                        <li key={indexTwo}>{listItem}</li>
                                    ))}
                                </ul>
                                : item.summary.text}
                            </td>
                            <td>{item.length}</td>
                            <td>{item.assessment}</td>
                            <td>{item.progress}</td>
                        </tr>
                    ))
                    }
                </TablePrimary>

            </div>
            <div className="space-50"></div>
            <div className="space-50"></div>
            <div className="space-50"></div>
            <CardSection 
                title={compliancePageData.sectionThree.title}
                subtitle={compliancePageData.sectionThree.subtitle}
                shortText={compliancePageData.sectionThree.shortText}
                image={{
                    src : require(`../../assets/images/sections/${compliancePageData.sectionThree.image.name}`),
                    alt : compliancePageData.sectionThree.image.alt
                }}
            />
            <div className="space-50"></div>
            <div className="space-50"></div>
            <div className="space-50"></div>
            <div className="wrapper-small">
                <section>
                    <TitleBorderLeft>{compliancePageData.sectionFour.title}</TitleBorderLeft>
                    <p className="text-paragraph">{compliancePageData.sectionFour.paragraphOne}</p>
                    <p className="text-paragraph">{compliancePageData.sectionFour.paragraphTwo}</p>
                    <p className="text-paragraph">{compliancePageData.sectionFour.paragraphThree}</p>
                    <p className="text-paragraph">{compliancePageData.sectionFour.paragraphFour}</p>
                    <TablePrimary
                        headers={compliancePageData.sectionFour.table.headers}
                        textDirection={["s", "e", "e", "e"]}
                    >
                        {compliancePageData.sectionFour.table.data.map((item, index) => (
                            <tr key={index}>
                                <td>{item.year}</td>
                                <td className="td-e">{item[2021]}</td>
                                <td className="td-e">{item[2022]}</td>
                                <td className="td-e">{item[2023]}</td>
                            </tr>
                        ))}
                    </TablePrimary>
                </section>
                <div className="space-50"></div>
                <div className="space-50"></div>
                <div className="space-50"></div>
                <section>
                    <TitleBorderLeft>{compliancePageData.sectionFive.title}</TitleBorderLeft>
                    <TablePrimary
                        headers={compliancePageData.sectionFive.table.headers}
                    >
                        {compliancePageData.sectionFive.table.data.map((item, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item}</td>
                            </tr>
                        ))}
                    </TablePrimary>
                    <p className="text-paragraph">{compliancePageData.sectionFive.table.paragraphOne}</p>
                    <p className="text-paragraph">{compliancePageData.sectionFive.table.paragraphTwo}</p>
                </section>
                <div className="space-50"></div>
                <div className="space-50"></div>
                <div className="space-50"></div>
            </div>
            <Footer withBlogs={false} />
        </div>
    </div>
    
    </main>
  )
}

export default CompliancePage